import { ReactElement } from "react";

import { FactorKey } from "types/factor/factor";

import styles from "./factor-icon.module.css";

const keyToIconMap = {
  [FactorKey.GoogleAuth]: styles.google,
  [FactorKey.OktaVerify]: styles.okta,
  [FactorKey.Sms]: styles.phone,
  [FactorKey.Call]: styles.phone,
  [FactorKey.WebAuthn]: styles.passkey,
};

const MfaIcon = ({ factorKey }: { factorKey: FactorKey }): ReactElement => {
  const iconClass = keyToIconMap[factorKey];

  return <div className={`${styles.mfaIcon} ${iconClass}`}></div>;
};

export default MfaIcon;
